import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { BuildingFragment } from '../../../generated/graphql'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { SystemContainerCharts } from '../../system-container/SystemContainerCharts'
import { EnergyType } from '../../../calculators/EnergyFlow'

type Props = {
  building?: BuildingFragment
}

export function BuildingCharts({ building }: Props): React.ReactElement {
  const { t } = useTranslation()
  const calculator = useReactiveVar(calculatorVar)

  if (!building) {
    return <></>
  }

  const buildingCalculator = calculator?.findBuilding(building.id)

  if (!buildingCalculator) {
    return <></>
  }

  const demands = buildingCalculator.getPrimaryDemands()

  return (
    <SystemContainerCharts
      title={t('building.tabs.basicInfo.charts')}
      chartTitlePrefix={t('building.tabs.basicInfo.consumption')}
      demands={demands}
      energyTypes={Object.values(EnergyType)}
    />
  )
}
